var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAADdklEQVRoBc2aDZEUMRCFGwfgAByAA3CAA0ABoIBTcKAAUAAOwAE4AAfgAK6+rc1Vz5vO3uZ3k6rUJDM7mX79+i+5M8u3+2b20sw+mdlvM/t/of7TzL6a2Yu8qPknr83s74UEP6WwX+cCgoXvCwJQcN/M7GGOBx5c0oRU2LvmsIPidy3HBPfxlcdHLQB4Vn96/HZONpjZNARVDcAOC63SngUW88/M3ngB1aSYZ23Qvzh5/CgA8yeZWMTGSkyormDGWw+sgOEQo/0D7LFHwxG9M/pxy/r3gsj6kQVJOB5IVeIRyWAU83zv7jMn0vQw2VciM+tuQACoxawQUiMM0U7NFw22MPRE5Ma8dkBaNMa7WhHAuAaTgwYdW6VDnN5bUXcgCHQlH/EfZMxHYamlTQGCySgDHszBMVtQmNkUIMj4PMMKMb/FdBP+aUD4oDo9rGB2Pdo0IJF5YW692jQg7wLT6pGfkiKmAMEHvHMzZpfZs00B8jkA0sPBvSKGA9EMDhsfvARmRq1E6dKS2YcD0fzBXNlI5cW1ACyZDgXCgYX6hjo4bCSwZPjaum4YELSeBExgmGvTqnW3VdUXMvNhQM51cK3DYEVZy8i+uT0ESEm4fRAwlz0N2Yi+nQwBEpmUOrgXQ7eqmGJp6dIdSBRuN6caHsFxHG1VS4vJKiB8OOosFrGhvw2w7MpwWClx/CogJC8EjnqKUOnK7jD6HbWXNnV81oje5Z7f+7NOFZAoIiXBS666K8TxdVucW083YxcFEh0zaV4ZDoR4X9u9cOwcfYsc3/8+jbswQhlBdOrRo5IkCsecvPjv6XtVpuU1OGIMK1TISftc76rDlgSCciLHPxWOlwUCmLcBK7nkWg2EF4n7vqvdtpodJkbO8CZ2+ycDWbwaiH6g12G0yGeR40cbsLOAaOJiS8rhAQ6YtFVTeqvQ0VzDMQqLmFfAyLajk7AXNSpaFqaPbGgbCzhVEWsi/YFAWoJEGdgL3nJo4NepHStrWAn/ULD72wUPoG7VFpnVwdTRMNEh2T9XqIXi1VoyOy/rxtSJ1/5hAgN6qFyhIYtGT5x8F3jIpAqGOT5DAGAhNFLSCRAtnQjKMVN0so9sYfbHxKApArPiPWTNng3wAJQ+Z6wIAhnPip6YEohXA0RQytVfJ/0YQF/MjIQDqNLeg00cnMoCWbIs3ADyH+v+7IWRdwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.224f550b2a29663e1c62672ef23021ec.svg";
export { ForwardRef as ReactComponent };